import getIntl from './intl'
import {
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_ERROR,
  toastShow,
} from 'mailup-web-components'

export const notifySuccess = (msg: string): void => {
  const intl = getIntl()
  toastShow(
    intl.formatMessage({
      id: msg,
    }),
    TOAST_VARIANT_SUCCESS,
  )
}

export const notifyError = (msg: string): void => {
  const intl = getIntl()
  toastShow(
    intl.formatMessage({
      id: msg,
    }),
    TOAST_VARIANT_ERROR,
  )
}
